import React from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaClock } from 'react-icons/fa';
import "../assets/styles/ContactForm.css";

const ContactForm = () => {
  return (
    <Container className="contact-container">
      <Row className="justify-content-center">
        <Col md={5} className="contact-info">
          <h2>Get in Touch</h2>
          <h3 style={{color: 'white'}} className="highlight">With Us</h3>
          <Card className="info-card mb-3">
            <Card.Body>
              <FaEnvelope className="icon" />
              <p>You can email us here</p>
              <a href="mailto:asyncvibe@gmail.com">asyncvibe@gmail.com</a>
            </Card.Body>
          </Card>
          <Card className="info-card mb-3">
            <Card.Body>
              <FaPhone className="icon" />
              <p>Or give us a call</p>
              <a href="tel:+923207110715">asyncvibe@gmail.com</a>
            </Card.Body>
          </Card>
          <Card className="info-card">
            <Card.Body>
              <FaClock className="icon" />
              <p>Business Hours</p>
              <span>12:00 PM - 9:00 PM</span>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} className="contact-form mt-5 pt-4">
          <Form>
            <Row>
              <Col>
                <Form.Group controlId="firstName">
                  <Form.Label className='contact-label'>First Name</Form.Label>
                  <Form.Control type="text" placeholder="First Name" />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="lastName">
                  <Form.Label className='contact-label'>Last Name</Form.Label>
                  <Form.Control type="text" placeholder="Last Name" />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId="email">
              <Form.Label className='contact-label'>Email</Form.Label>
              <Form.Control type="email" placeholder="Enter Email" />
            </Form.Group>

            <Form.Group controlId="budget">
              <Form.Label className='contact-label'>Budget</Form.Label>
              <Form.Control type="text" placeholder="$ 1000" />
            </Form.Group>

            <Form.Group controlId="message">
              <Form.Label className='contact-label'>Tell us about the project?</Form.Label>
              <Form.Control as="textarea" rows={4} />
            </Form.Group>

            <Button className="submit-btn" type="submit">Submit</Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactForm;
